<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Quote Type"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="quoteTypes"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Quote Types.</div>
      </template>

      <template #empty> No Related Quote Types. Accounts found! </template>
      <template #loading> Loading Related Quote Types. Please wait. </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="typeCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.typeCode ? slotProps.data.typeCode : "" }}
        </template>
      </Column>
      <Column field="typeName" header="Description" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.typeName ? slotProps.data.typeName : "" }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editQuoteTypes(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="quoteTypesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Quote Type"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="quoteType.typeCode"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Description:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="quoteType.typeName"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="quoteType.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="quoteTypesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Quote Type?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteQuoteTypes"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  quotationService: null,
  data: () => ({
    quoteTypesForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    quoteTypes: null,
    quoteType: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.quoteType = {};
      this.quoteTypesForm = true;
    },
    openConfirmation(data) {
      this.quoteType = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editQuoteTypes(data) {
      this.quoteType = data;
      this.quoteTypesForm = true;
    },
    async deleteQuoteTypes() {
      this.closeConfirmation();
      await this.quotationService.deleteQuotationTypes(this.quoteType.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Quote type removed",
        life: 5000
      });
      this.getAllQuotationTypes();
    },
    save() {
      if (!this.quoteType.id) {
        this.quotationService
          .postQuotationTypes(this.quoteType)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Quote type added",
              life: 5000
            });
            this.getAllQuotationTypes();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving quotation type",
              life: 5000
            });
          });
      } else {
        this.quotationService
          .putQuotationTypes(this.quoteType, this.quoteType.id)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Quote type updated",
              life: 5000
            });
            this.getAllQuotationTypes();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating quotation status",
              life: 5000
            });
          });
      }
      this.quoteTypesForm = false;
    },
    getAllQuotationTypes() {
      this.loading = true;

      this.quotationService
        .getAllQuotationTypes()
        .then(data => {
          this.quoteTypes = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quote types",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "quotetypes"'
          });
        });
    }
  },
  created() {
    this.quotationService = new QuotationService();
  },
  mounted() {
    this.getAllQuotationTypes();
  }
};
</script>
